import {CommandBase} from "@shared/commands/command-base";
import {Dac6ReporterConfig} from "../../../orbitax-dac6-reporter-config";
import { Configuration } from "@shared/models/configuration";
/**
 * Created by shakibuz.zaman on 7/15/2020.
 */
export class TransmitFileCommand extends CommandBase {
  constructor(public items: any[], public countryCode: string, public metaData: any,api:string = 'TransmissionApi') {
    super(`${Configuration.getConfig(api)}Command/TransmitFile`);
  }
}
